var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import OauthProviderList from '../components/login/OauthProviderList';
import UserFeedback from '../components/UserFeedback';
import { formatSchoolName, mergeSchools } from '../utils/salePoint/schoolUtil';
import useListSchools from '../hooks/useListSchools';
import { browserAuthUrl } from '../utils/api/browserAuthApi';
import { getQueryParamByName } from '../utils/urlDecoder';
var getApiErrorMessage = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var data, validationMessage, e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, response.json()];
            case 1:
                data = _b.sent();
                validationMessage = (_a = data.errors) === null || _a === void 0 ? void 0 : _a.map(function (error) { return error.message; }).filter(Boolean).join(', ');
                return [2 /*return*/, data.detail
                        || data.title
                        || validationMessage
                        || 'Kunne ikke registrere brukeren. Prøv igjen.'];
            case 2:
                e_1 = _b.sent();
                return [2 /*return*/, 'Kunne ikke registrere brukeren. Prøv igjen.'];
            case 3: return [2 /*return*/];
        }
    });
}); };
var parseSchoolId = function (value) {
    if (typeof value !== 'string' || value.trim() === '') {
        return null;
    }
    var schoolId = Number(value);
    return Number.isFinite(schoolId) ? schoolId : null;
};
var getSafeRedirect = function () {
    var redirect = getQueryParamByName('redirect');
    if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//')) {
        return null;
    }
    return redirect;
};
var redirectToLogin = function (email) {
    var params = ['account_exists=1'];
    var safeRedirect = getSafeRedirect();
    if (email.trim()) {
        params.push("email=" + encodeURIComponent(email.trim()));
    }
    if (safeRedirect) {
        params.push("redirect=" + encodeURIComponent(safeRedirect));
    }
    window.location.href = "/logg_inn?" + params.join('&');
};
var RegisterUserPage = function () {
    var _a = useListSchools(), schools = _a.schools, isLoading = _a.isLoading;
    var schoolsAsList = mergeSchools(schools);
    var _b = React.useState(null), registrationError = _b[0], setRegistrationError = _b[1];
    var _c = React.useState(false), isRegistered = _c[0], setIsRegistered = _c[1];
    var _d = React.useState(false), isSubmitting = _d[0], setIsSubmitting = _d[1];
    // object implementasjon
    var _e = React.useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
    }), inputState = _e[0], setInputState = _e[1];
    var _f = React.useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
    }), inputErrorState = _f[0], setInputErrorState = _f[1];
    var handleInputChange = function (e) {
        // prepopulate the new state with values from current state
        var newState = __assign({}, inputState);
        // names of targets should correspond to the names in state object to use this
        // newState[name] = value;
        // since linting does not allow usage of names like confirm_password in object
        // It was chosen to make a switch case statement instead of
        // one if statement for confirmPassword
        switch (e.target.name) {
            case 'name':
                newState.name = e.target.value;
                break;
            case 'email':
                newState.email = e.target.value;
                break;
            case 'password':
                newState.password = e.target.value;
                break;
            case 'confirm_password':
                newState.confirmPassword = e.target.value;
                break;
            default:
                break;
        }
        setInputState(newState);
    };
    var validateName = function () {
        var error = '';
        var newErrorState = __assign({}, inputErrorState);
        if (!inputState.name) {
            error = 'Navn er obligatorisk';
        }
        newErrorState.name = error;
        setInputErrorState(newErrorState);
        return newErrorState.name.length === 0;
    };
    var validateEmail = function () {
        var error = '';
        var newErrorState = __assign({}, inputErrorState);
        if (!inputState.email) {
            error = 'E-post er obligatorisk';
        }
        else if (!/\S+@\S+\.\S+/.test(inputState.email)) {
            error = 'E-postadressen er ugyldig';
        }
        newErrorState.email = error;
        setInputErrorState(newErrorState);
        return newErrorState.email.length === 0;
    };
    // at least 1 small letter, 1 big letter, 1 digit, 12 length
    var hasLower = /[a-z]/;
    var hasUpper = /[A-Z]/;
    var hasDigit = /\d/;
    var allowedLength = /^.{12,}$/;
    var validatePassword = function () {
        var error = '';
        var newErrorState = __assign({}, inputErrorState);
        // variable to not repeat changes in if statement
        var passwordState = inputState.password;
        if (!passwordState || !allowedLength.test(passwordState)) {
            error = 'Passord må være 12 tegn';
        }
        else if (!hasDigit.test(passwordState)) {
            error = 'Passord må inneholde minst et nummer';
        }
        else if (!hasUpper.test(passwordState) || !hasLower.test(passwordState)) {
            error = 'Passord må ha store og små bokstaver';
        }
        newErrorState.password = error;
        setInputErrorState(newErrorState);
        // validate confirm password field again after changing password
        // cant just call validateConfirmPassword because they override same object
        var confirmPasswordError = '';
        if (inputState.confirmPassword
            && inputState.password !== inputState.confirmPassword) {
            confirmPasswordError = 'Passordene matcher ikke';
        }
        newErrorState.confirmPassword = confirmPasswordError;
        return newErrorState.password.length === 0;
    };
    var validateConfirmPassword = function () {
        var error = '';
        var newErrorState = __assign({}, inputErrorState);
        if (inputState.password !== inputState.confirmPassword) {
            error = 'Passordene matcher ikke';
        }
        newErrorState.confirmPassword = error;
        setInputErrorState(newErrorState);
        return newErrorState.confirmPassword.length === 0;
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, formData, response, _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    setRegistrationError(null);
                    isValid = validateName()
                        && validateEmail()
                        && validatePassword()
                        && validateConfirmPassword();
                    if (!isValid) {
                        return [2 /*return*/];
                    }
                    formData = new FormData(e.currentTarget);
                    setIsSubmitting(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, fetch(browserAuthUrl('register'), {
                            method: 'POST',
                            credentials: 'include',
                            headers: [
                                ['Accept', 'application/json'],
                                ['Content-Type', 'application/json'],
                            ],
                            body: JSON.stringify({
                                name: inputState.name,
                                email: inputState.email,
                                password: inputState.password,
                                confirmPassword: inputState.confirmPassword,
                                schoolId: parseSchoolId(formData.get('school_id')),
                                hideName: false,
                            }),
                        })];
                case 2:
                    response = _b.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    if (response.status === 409) {
                        redirectToLogin(inputState.email);
                        return [2 /*return*/];
                    }
                    _a = setRegistrationError;
                    return [4 /*yield*/, getApiErrorMessage(response)];
                case 3:
                    _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/];
                case 4:
                    setIsRegistered(true);
                    return [3 /*break*/, 7];
                case 5:
                    error_1 = _b.sent();
                    setRegistrationError('Kunne ikke registrere brukeren. Prøv igjen.');
                    return [3 /*break*/, 7];
                case 6:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    if (isRegistered) {
        return React.createElement(React.Fragment, null,
            React.createElement("h1", null, "Bekreft e-postadresse"),
            React.createElement(UserFeedback, { status: "success" },
                React.createElement("p", null, "Vi har n\u00E5 sendt deg en e-post med en kobling for \u00E5 aktivere kontoen. Hvis du allerede hadde startet registreringen, har du f\u00E5tt en ny aktiveringslenke. Du m\u00E5 \u00E5pne koblingen i e-posten f\u00F8r du kan logge inn.")));
    }
    return React.createElement(React.Fragment, null,
        React.createElement("h1", null, "Registrer ny bruker"),
        React.createElement("p", null, "Registrer deg med som ny bruker ved \u00E5 enten ta i bruk skjemaet, eller gjennom din Facebook, Google eller universitetsbruker"),
        React.createElement("p", null,
            "Ved \u00E5 registrere en bruker p\u00E5 iBok.no ",
            React.createElement("strong", null, "samtykker"),
            " du til ",
            React.createElement("a", { href: "/betingelser", target: "_blank" }, "brukervilk\u00E5rene"),
            " og ",
            React.createElement("a", { href: "/personvern", target: "_blank" }, "Personvernerkl\u00E6ringen")),
        React.createElement("div", { className: "horizontal" },
            React.createElement("section", null,
                React.createElement("h2", null, "Gjennom iBok"),
                React.createElement("form", { action: "registrer", method: "post", className: "vertical", onSubmit: handleSubmit },
                    registrationError && React.createElement(UserFeedback, { status: "error" },
                        React.createElement("p", null, registrationError)),
                    React.createElement("label", { className: "required" },
                        "Navn",
                        React.createElement("input", { id: "name", type: "text", name: "name", placeholder: "Ola Nordmann", autoComplete: "name", required: true, onChange: function (e) { return handleInputChange(e); }, onBlur: validateName })),
                    inputErrorState.name && React.createElement("span", { className: 'error' }, inputErrorState.name),
                    React.createElement("label", { className: "required" },
                        "E-postadresse",
                        React.createElement("input", { id: "email", type: "email", name: "email", placeholder: "example@example.com", title: "M\u00E5 v\u00E6re en gyldig e-postadresse (ola@nordmann.no)", required: true, autoComplete: "email", autoFocus: true, onChange: function (e) { return handleInputChange(e); }, onBlur: validateEmail })),
                    inputErrorState.email && React.createElement("span", { className: 'error' }, inputErrorState.email),
                    React.createElement("label", { className: "required" },
                        "Passord",
                        React.createElement("input", { id: "password", type: "password", name: "password", placeholder: "******", title: "Passord m\u00E5 inneholde minst et nummer, ha store og sm\u00E5 bokstaver og v\u00E6re minst 12 tegn", autoComplete: "new-password", required: true, onChange: function (e) { return handleInputChange(e); }, onBlur: validatePassword })),
                    inputErrorState.password && React.createElement("span", { className: 'error' }, inputErrorState.password),
                    React.createElement("label", { className: "required" },
                        "Gjenta passord",
                        React.createElement("input", { id: "confirm_password", type: "password", name: "confirm_password", placeholder: "******", autoComplete: "new-password", required: true, onChange: function (e) { return handleInputChange(e); }, onBlur: validateConfirmPassword })),
                    inputErrorState.confirmPassword && React.createElement("span", { className: 'error' }, inputErrorState.confirmPassword),
                    React.createElement("label", null,
                        "Studiested",
                        React.createElement("select", { id: "school_id", name: "school_id" },
                            isLoading && React.createElement("option", { value: "" }, "Henter skoler..."),
                            schoolsAsList.length > 0 && React.createElement("option", { value: "Ikke valgt / ikke student" }, "Ikke valgt / ikke student"),
                            schoolsAsList.map(function (school) { return React.createElement("option", { key: "school-" + school.id, value: school.id }, formatSchoolName(school)); }))),
                    React.createElement("button", { type: "submit", disabled: isSubmitting }, isSubmitting ? 'Registrerer...' : 'Registrer bruker'))),
            React.createElement("section", null,
                React.createElement("h2", null, "Gjennom Tredjepartstjenester"),
                React.createElement(OauthProviderList, null),
                React.createElement(React.Fragment, null,
                    React.createElement("a", { href: "/hjelp/#oauth" }, "Hva er dette?"),
                    React.createElement("p", null, "OBS! Dersom du har problemer med registrering med tredjepartstjenester, pr\u00F8v \u00E5 registrere deg gjennom iBok.")))));
};
export default RegisterUserPage;
